import { ChevronLeftIcon, EllipsisVerticalIcon, MoonIcon, SunIcon } from "@heroicons/react/24/solid"
import { ReactNode, useEffect, useState } from "react"
import { getInitialTheme, setTheme, toggleTheme } from "../app/theme.ts"
import { authApi, useLogoutMutation } from "../features/auth/service.ts"
import { useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import { useSelection } from "@/app/department-context.tsx"

type Props = {
  menuItems: ReactNode | ((isSidebarOpen: boolean) => ReactNode)
  userInfo: ReactNode
  bottomMenu?: ReactNode | ((isSidebarOpen: boolean) => ReactNode)
  children: ReactNode
}
export const BaseLayout = ({ menuItems, userInfo, bottomMenu, children }: Props) => {
  const [isSidebarOpen, setSidebarOpen] = useState(true)
  const [logout] = useLogoutMutation()
  const [currentTheme, setCurrentTheme] = useState(getInitialTheme())
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { clearSelection } = useSelection()

  useEffect(() => {
    setTheme(currentTheme)
  }, [currentTheme])

  const onLogout = async () => {
    await logout({})
    dispatch(authApi.util.resetApiState())
    clearSelection()
    navigate("/")
  }
  const handleThemeToggle = () => {
    toggleTheme()
    setCurrentTheme(getInitialTheme())
  }
  return (
    <div className="flex">
      <aside
        className={`bg-teal-50 dark:bg-teal-950 text-teal-800 transition-all duration-300 ${
          isSidebarOpen ? "w-60 min-w-60" : "w-20 min-w-20"
        } h-screen sticky top-0`}
      >
        <div className="flex items-center justify-between p-4">
          <h1
            className={`text-2xl font-bold transition-opacity duration-300 ${
              isSidebarOpen ? "opacity-100" : "opacity-0"
            }`}
          >
            Dialogics
          </h1>
        </div>
        <div className="p-4 justify-end flex translate-x-7.5 rounded-lg">
          <button
            onClick={() => setSidebarOpen(!isSidebarOpen)}
            className="p-2 rounded-full hover:bg-teal-100 bg-teal-50 dark:bg-teal-950 cursor-pointer"
          >
            <ChevronLeftIcon
              className={`w-6 h-6 transition-transform duration-300 ${isSidebarOpen ? "" : "rotate-180"}`}
            />
          </button>
        </div>
        <ul className="menu p-4 overflow-hidden">
          {typeof menuItems === "function" ? menuItems(isSidebarOpen) : menuItems}
        </ul>
        <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-teal-100">
          <div className="flex items-center justify-between">
            <div className={`flex flex-col ${isSidebarOpen ? "" : "hidden"}`}>{userInfo}</div>
            <div className="dropdown dropdown-top">
              <div
                tabIndex={0}
                className="p-2 rounded-full hover:bg-teal-100 bg-teal-50 dark:bg-teal-950 cursor-pointer"
              >
                <EllipsisVerticalIcon className="w-6 h-6" />
              </div>
              <ul
                tabIndex={0}
                className="dropdown-content menu p-2 shadow bg-base-100 dark:bg-teal-950 rounded-box w-52 "
              >
                {typeof bottomMenu === "function" ? bottomMenu(isSidebarOpen) : bottomMenu}
                <li>
                  <label className="flex cursor-pointer gap-2">
                    <SunIcon className="h-6 w-6" />
                    <input
                      type="checkbox"
                      value="synthwave"
                      className="toggle theme-controller"
                      checked={currentTheme === "dark"}
                      onChange={handleThemeToggle}
                    />
                    <MoonIcon className="h-6 w-6" />
                  </label>
                </li>
                <li>
                  <button onClick={onLogout}>Выход</button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </aside>
      {children}
    </div>
  )
}
